import http from '@/utils/http';
import { getQueryDefinition } from '@intelligence/services/common';

import type { AxiosRequestConfig } from 'axios';

/**
 * 获取筛选器方案详情
 * @param params
 * @return 筛选器方案详情
 */
export const fetchFilterTagNameDetails = (params: IRecord<IEntityQueryConfig>): IBaseResponse => {
  return getQueryDefinition(params);
};

/**
 * 获取指标有数据的日期范围
 * @param payload 参数对象
 * @param config axios 配置对象
 */
export const fetchMetricsDateRanges = (
  payload: IMetricsDateRangesFetchParams,
  config?: AxiosRequestConfig,
): IBaseResponse<IMetricDateRange[] | null> => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/common/metric_date',
    method: 'post',
    data: payload,
    rawData: true,
  }) as any;
};

/**
 * 获取通用指标游戏数据
 * @param payload 接口入参
 * @return 指标游戏数据
 */
export const fetchMetricDataGames = (
  payload: IMetricDataGamesFetchParams,
  config?: AxiosRequestConfig,
): IBaseResponse<IPaginationData<IMetricDataGame>> => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/mobile/metrics',
    method: 'post',
    data: payload,
    rawData: true,
  }) as any;
};

export const fetchRegionOptionsMapByStoreTops = (params: { target: IRecord<string[]> }): IBaseResponse => {
  return http({
    url: '/api/v1/intelligence_pc/common/metric_filter',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};
